module.exports = {
  footerText: `Copyright Kitegateway © ${new Date().getFullYear()}`,
};
